import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationES from "./locales/English/translation.json";
import translationAR from "./locales/Arabic/translation.json";
const fallbackLng = ["en"];
const resources = {
  en: {
    translation: translationES,
  },
  ar: {
    translation: translationAR,
  },
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
